// extracted by mini-css-extract-plugin
module.exports = {"button":"ToolButton_button__Kb3U8","colorInput":"ToolButton_colorInput__3jYbV"};